module.exports = __webpack_public_path__ + "static/img/weather_025.a7655657.svg";